var _rect, _path, _path2, _path3, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhotoIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 192,
    height: 260,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 260,
    rx: 8,
    fill: "#E6E5FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M140.266 188.123H53.762c-.852 0-1.545-.694-1.514-1.545.368-10.141 4.364-16.614 9.198-20.718 6.874-5.836 15.582-7.597 35.38-7.597 19.644 0 27.795 1.848 34.564 7.597 4.847 4.116 9.911 10.597 10.382 20.719.039.85-.655 1.544-1.506 1.544Z",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m109.507 151.122 2.665-10.182-31.079-2.258 3.776 12.441a9.25 9.25 0 0 1-.45 6.558l-.423.918 9.628 6.892a6.167 6.167 0 0 0 7.117.043l9.94-6.935-.499-.999a9.249 9.249 0 0 1-.675-6.478Z",
    fill: "#B1B0F5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m71.499 111.175 1.325-19.886 28.294-3.926 22.735 24.838-5.423 24.017-19.94 15.698a1.541 1.541 0 0 1-1.862.034l-12.823-9.369-6.674-3.284-5.632-28.122Z",
    fill: "#E6E5FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M70.308 74.227c6.717-2.963 12.28-2.709 21.79-.413 1.1.265 2.24.302 3.355.108 3.5-.61 11.696-1.906 17.267-1.748 7.252.205 15.163 7.8 18.02 12.111 2.857 4.31 14.378 31.713 12.746 34.486-1.236 2.098-5.259 4.313-7.142 5.265a3.271 3.271 0 0 0-1.473 1.473l-2.858 5.847a3.083 3.083 0 0 0 1.249 4.035l2.069 1.173a3.085 3.085 0 0 1 1.562 2.682v.753a3.23 3.23 0 0 1-1.225 2.509c-3.029 2.434-10.35 8.85-6.466 11.159 4.276 2.542-5.374.587-7.66.102a2.994 2.994 0 0 1-.892-.35l-8.169-4.811a3.082 3.082 0 0 1-1.519-2.656v-3.16c0-.794.306-1.556.854-2.13l5.767-6.04c.412-.432.69-.973.8-1.559l2.208-11.739c.2-1.067-.89-1.913-1.874-1.454a1.333 1.333 0 0 1-1.88-.998l-.846-5.304c-.238-1.496-1.532-2.598-3.035-2.796-2.558-.337-6.242-1.246-7.487-3.702-1.46-2.878-4.594-8.102-6.137-10.644a3.056 3.056 0 0 0-2.618-1.467H84.929c-.51 0-1.011-.126-1.46-.368l-2.896-1.557a3.083 3.083 0 0 0-4.485 2.115l-3.031 15.261c-.074.37-.079.751-.015 1.124l3.7 21.5c.103.604.385 1.164.808 1.607l5.75 6.021c.547.574.853 1.336.853 2.13v7.174c0 1.247-.75 2.37-1.902 2.848l-1.666.692a3.072 3.072 0 0 1-.805.212l-10.458 1.291a3.09 3.09 0 0 1-1.496-.187l-6.538-2.544a3.003 3.003 0 0 1-1.12-.767c-1.554-1.693-.707-4.478 1.453-5.263 2.176-.791 4.412-1.851 5.171-3.05-2.972-1.169-7.615-3.586-10.044-4.882a3.041 3.041 0 0 1-1.603-2.689v-2.57c0-.741.267-1.457.752-2.018l6.859-7.924c.44-.509.5-1.244.147-1.817l-7.565-12.273a3.09 3.09 0 0 1-.306-.662l-2.226-6.83c-.434-1.333.1-2.771 1.363-3.379 2.683-1.289 6.2-2.79 6.47-4.426.44-2.669 1.758-16.012 9.669-19.501Z",
    fill: "#8E8CEE"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 103.808,
    y1: 154.113,
    x2: 82.175,
    y2: 203.572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8987FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484,
    stopColor: "#8A88FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484,
    stopColor: "#A09EFF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotoIcon);
export default __webpack_public_path__ + "static/media/photo-icon.52fe48c6d5607257208aeb4ec23f3836.svg";
export { ForwardRef as ReactComponent };